import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import { getWordpressPostData } from '../services/commonDataService';

const CommonDataContext = createContext();

export const CommonDataContextProvider = ({ children }) => {

    const [commonData, setCommonData] = useState({});
    const shouldFetchAmpFeaturedPosts = window.location.pathname.includes('/account-summary');

    const fetchWordpressPostData = async (id, url) => {
        const response = await getWordpressPostData(id, url);
        setCommonData(prevState => ({
            ...prevState,
            [id]: response
        }));
    };

    useEffect(() => {
        if (shouldFetchAmpFeaturedPosts === true) {
            fetchWordpressPostData('ampFeaturedCards', process.env.REACT_APP_WP_ACCOUNT_SUMMARY_FEATURE_CARDS_URL);
        }
    }, [shouldFetchAmpFeaturedPosts]);

    const value = useMemo(() => ({ commonData }), [commonData]);

    return (
        <CommonDataContext.Provider value={value}>
            {children}
        </CommonDataContext.Provider>
    );
};

export const useCommonDataContext = () => useContext(CommonDataContext);
export { CommonDataContext };